import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { ABOUT, VALUES, MANDATES } from "@/data/content";
import PageHero from "@/components/site/PageHero";
import CTABand from "@/components/site/CTABand";

function Statement({ eyebrow, body, large }) {
  return (
    <section className="m61-section border-t border-m61-line">
      <div className="m61-container grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-3">
          <p className="m61-eyebrow">{eyebrow}</p>
        </div>
        <div className="lg:col-span-9">
          <p className={`text-xl leading-relaxed ${large ? "text-m61-text" : "text-m61-muted"}`}>
            {body}
          </p>
        </div>
      </div>
    </section>
  );
}

export default function About() {
  useDocumentTitle("About Meta61 | Our purpose, vision, mission, and values");
  return (
    <div>
      <PageHero
        eyebrow="About Meta61"
        title="An Australian company building technology the"
        accent="world can trust."
        subhead="Meta61 is a think tank and advisory at the convergence of AI and emerging technology — uniting deep technical capability with standards-grade governance to make transformation secure, sustainable, and sovereign."
      />

      <section className="m61-section">
        <div className="m61-container grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-3"><p className="m61-eyebrow">Who we are</p></div>
          <div className="lg:col-span-9 text-xl text-m61-muted leading-relaxed">{ABOUT.whoWeAre}</div>
        </div>
      </section>

      <Statement eyebrow="Purpose — why we exist" body={ABOUT.purpose} large />
      <Statement eyebrow="Vision — the future we work toward" body={ABOUT.vision} />
      <Statement eyebrow="Mission — what we do about it" body={ABOUT.mission} />

      {/* Values */}
      <section className="m61-section border-t border-m61-line bg-m61-surface/40">
        <div className="m61-container">
          <p className="m61-eyebrow mb-10">Our values</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-m61-line border border-m61-line">
            {VALUES.map((v, i) => (
              <div key={v.title} className="bg-m61-surface p-8">
                <span className="font-mono text-xs text-m61-muted">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="m61-h3 mt-3 mb-2">{v.title}</h3>
                <p className="text-m61-muted leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Statement eyebrow="How we hold these together" body={ABOUT.holdTogether} />

      {/* Two mandates */}
      <section className="m61-section border-t border-m61-line">
        <div className="m61-container">
          <p className="m61-eyebrow mb-10">The two mandates</p>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {MANDATES.map((m) => (
              <Link key={m.title} to="/frameworks" className="m61-card p-8 group">
                <h3 className="m61-h3 mb-3">{m.title}</h3>
                <span className="text-m61-cyan text-sm inline-flex items-center gap-2 group-hover:gap-3 transition-all">
                  Explore frameworks <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
